import { PermissionModeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/permission-gps.enum';

export const BULK_GPS_CONFIG_MAX_PARTNERS = 500;

export interface BulkGpsConfigGpsConfig {
  useGps: boolean;
  useGpsMode?: PermissionModeEnum;
  distanceBtwSellerAndCustomer?: number;
}

export interface BulkGpsConfigRequest {
  businessPartnerIds?: string[];
  applyToAllAssigned?: boolean;
  gpsConfig: BulkGpsConfigGpsConfig;
}

export interface BulkGpsConfigResponse {
  updatedCount: number;
  businessPartnerIds: string[];
  subRouteId: string;
}
